/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementDTO,
  AgreementDTOOptional,
  AgreementDTOMetaI,
  AgreementDTOTrackedI,
} from "./agreement-dto";
import { AgreementDTOTracked, AgreementDTOMeta } from "./agreement-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogCategoryDTO,
  CatalogCategoryDTOOptional,
  CatalogCategoryDTOMetaI,
  CatalogCategoryDTOTrackedI,
} from "./catalog-category-dto";
import {
  CatalogCategoryDTOTracked,
  CatalogCategoryDTOMeta,
} from "./catalog-category-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogDiscountPublicDTO,
  CatalogDiscountPublicDTOOptional,
  CatalogDiscountPublicDTOMetaI,
  CatalogDiscountPublicDTOTrackedI,
} from "./catalog-discount-public-dto";
import {
  CatalogDiscountPublicDTOTracked,
  CatalogDiscountPublicDTOMeta,
} from "./catalog-discount-public-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogFull,
  CatalogFullOptional,
  CatalogFullMetaI,
  CatalogFullTrackedI,
} from "./catalog-full";
import { CatalogFullTracked, CatalogFullMeta } from "./catalog-full";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemPublicDTO,
  CatalogItemPublicDTOOptional,
  CatalogItemPublicDTOMetaI,
  CatalogItemPublicDTOTrackedI,
} from "./catalog-item-public-dto";
import {
  CatalogItemPublicDTOTracked,
  CatalogItemPublicDTOMeta,
} from "./catalog-item-public-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogSharedDTO,
  CatalogSharedDTOOptional,
  CatalogSharedDTOMetaI,
  CatalogSharedDTOTrackedI,
} from "./catalog-shared-dto";
import {
  CatalogSharedDTOTracked,
  CatalogSharedDTOMeta,
} from "./catalog-shared-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogTaxDTO,
  CatalogTaxDTOOptional,
  CatalogTaxDTOMetaI,
  CatalogTaxDTOTrackedI,
} from "./catalog-tax-dto";
import { CatalogTaxDTOTracked, CatalogTaxDTOMeta } from "./catalog-tax-dto";

/**
 *
 * @export
 * @interface CatalogPublicDTO
 */
export interface CatalogPublicDTOOptional extends CatalogFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogPublicDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  catalogName?: string;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogPublicDTO
   */
  categories?: CatalogCategoryDTOOptional[];
  /**
   *
   * @type {Array<CatalogItemPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  items?: CatalogItemPublicDTOOptional[];
  /**
   *
   * @type {Array<CatalogDiscountPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  discounts?: CatalogDiscountPublicDTOOptional[];
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogPublicDTO
   */
  taxes?: CatalogTaxDTOOptional[];
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogPublicDTO
   */
  agreements?: AgreementDTOOptional[];
}

export interface CatalogPublicDTO
  extends CatalogPublicDTOOptional, CatalogFull, CatalogSharedDTO {
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  startActive?: Date;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  endActive?: Date;
  /**
   *
   * @type {number}
   * @memberof CatalogPublicDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  catalogName?: string;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogPublicDTO
   */
  categories?: CatalogCategoryDTO[];
  /**
   *
   * @type {Array<CatalogItemPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  items?: CatalogItemPublicDTO[];
  /**
   *
   * @type {Array<CatalogDiscountPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  discounts?: CatalogDiscountPublicDTO[];
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogPublicDTO
   */
  taxes?: CatalogTaxDTO[];
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogPublicDTO
   */
  agreements?: AgreementDTO[];
}

export interface CatalogPublicDTOTrackedI extends CatalogFullOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogPublicDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  startActive?: Date;
  startActiveIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  endActive?: Date;
  endActiveIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogPublicDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogPublicDTO
   */
  catalogName?: string;
  catalogNameIsSet: boolean;
  /**
   *
   * @type {Array<CatalogCategoryDTO>}
   * @memberof CatalogPublicDTO
   */
  categories?: CatalogCategoryDTOTrackedI[];
  categoriesIsSet: boolean;
  /**
   *
   * @type {Array<CatalogItemPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  items?: CatalogItemPublicDTOTrackedI[];
  itemsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogDiscountPublicDTO>}
   * @memberof CatalogPublicDTO
   */
  discounts?: CatalogDiscountPublicDTOTrackedI[];
  discountsIsSet: boolean;
  /**
   *
   * @type {Array<CatalogTaxDTO>}
   * @memberof CatalogPublicDTO
   */
  taxes?: CatalogTaxDTOTrackedI[];
  taxesIsSet: boolean;
  /**
   *
   * @type {Array<AgreementDTO>}
   * @memberof CatalogPublicDTO
   */
  agreements?: AgreementDTOTrackedI[];
  agreementsIsSet: boolean;
}

transformDatesMap.set("CatalogPublicDTO", function (model: CatalogPublicDTO) {
  if (typeof model.startActive == "string")
    model.startActive = new Date(model.startActive);
  if (typeof model.endActive == "string")
    model.endActive = new Date(model.endActive);
  const transformDatescategories = transformDatesMap.get("CatalogCategoryDTO");
  if (transformDatescategories) {
    model.categories?.forEach((sub) => {
      transformDatescategories(sub);
    });
  }
  const transformDatesitems = transformDatesMap.get("CatalogItemPublicDTO");
  if (transformDatesitems) {
    model.items?.forEach((sub) => {
      transformDatesitems(sub);
    });
  }
  const transformDatesdiscounts = transformDatesMap.get(
    "CatalogDiscountPublicDTO",
  );
  if (transformDatesdiscounts) {
    model.discounts?.forEach((sub) => {
      transformDatesdiscounts(sub);
    });
  }
  const transformDatestaxes = transformDatesMap.get("CatalogTaxDTO");
  if (transformDatestaxes) {
    model.taxes?.forEach((sub) => {
      transformDatestaxes(sub);
    });
  }
  const transformDatesagreements = transformDatesMap.get("AgreementDTO");
  if (transformDatesagreements) {
    model.agreements?.forEach((sub) => {
      transformDatesagreements(sub);
    });
  }
});

export type CatalogPublicDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: true
  startActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  endActive: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  catalogName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  categories: PropertyMeta<CatalogCategoryDTOMetaI>;
  //isDate: false
  //isDatetime: false
  items: PropertyMeta<CatalogItemPublicDTOMetaI>;
  //isDate: false
  //isDatetime: false
  discounts: PropertyMeta<CatalogDiscountPublicDTOMetaI>;
  //isDate: false
  //isDatetime: false
  taxes: PropertyMeta<CatalogTaxDTOMetaI>;
  //isDate: false
  //isDatetime: false
  agreements: PropertyMeta<AgreementDTOMetaI>;
}>;

export var CatalogPublicDTOMeta: CatalogPublicDTOMetaI =
  {} as CatalogPublicDTOMetaI;
CatalogPublicDTOMeta = typeMeta("CatalogPublicDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  startActive: propertyMeta(
    "startActive",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  endActive: propertyMeta("endActive", false, false, false, MetaTypesBase.Date),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  catalogName: propertyMeta(
    "catalogName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  categories: propertyMeta(
    "categories",
    true,
    false,
    false,
    CatalogCategoryDTOMeta,
  ),
  items: propertyMeta("items", true, false, false, CatalogItemPublicDTOMeta),
  discounts: propertyMeta(
    "discounts",
    true,
    false,
    false,
    CatalogDiscountPublicDTOMeta,
  ),
  taxes: propertyMeta("taxes", true, false, false, CatalogTaxDTOMeta),
  agreements: propertyMeta("agreements", true, false, false, AgreementDTOMeta),
});

const metaI = CatalogPublicDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CatalogFullMeta]);
  metaI.isDeleted.inheritedFrom = CatalogFullMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogFullMeta.isNew;
  metaI.startActive.inheritedFrom = CatalogFullMeta.startActive;
  metaI.endActive.inheritedFrom = CatalogFullMeta.endActive;
  metaI.assignId.inheritedFrom = CatalogFullMeta.assignId;
  metaI.catalogName.inheritedFrom = CatalogFullMeta.catalogName;
  metaI.categories.inheritedFrom = CatalogFullMeta.categories;
  metaI.items.inheritedFrom = CatalogFullMeta.items;
  metaI.discounts.inheritedFrom = CatalogFullMeta.discounts;
  metaI.taxes.inheritedFrom = CatalogFullMeta.taxes;
  metaI.agreements.inheritedFrom = CatalogFullMeta.agreements;
  metaI.interfaces = metaI.interfaces.concat([CatalogSharedDTOMeta]);
  metaI.isDeleted.inheritedFrom = CatalogSharedDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogSharedDTOMeta.isNew;
  metaI.startActive.inheritedFrom = CatalogSharedDTOMeta.startActive;
  metaI.endActive.inheritedFrom = CatalogSharedDTOMeta.endActive;
  metaI.assignId.inheritedFrom = CatalogSharedDTOMeta.assignId;
  metaI.catalogName.inheritedFrom = CatalogSharedDTOMeta.catalogName;
  metaI.categories.inheritedFrom = CatalogSharedDTOMeta.categories;
  metaI.items.inheritedFrom = CatalogSharedDTOMeta.items;
  metaI.discounts.inheritedFrom = CatalogSharedDTOMeta.discounts;
  metaI.taxes.inheritedFrom = CatalogSharedDTOMeta.taxes;
  metaI.agreements.inheritedFrom = CatalogSharedDTOMeta.agreements;
});

export class CatalogPublicDTOTracked
  extends CatalogFullTracked
  implements CatalogPublicDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  startActive__I?: Date = undefined;
  startActiveIsSet: boolean = false;
  set startActive(v: undefined | Date) {
    if (v !== undefined) {
      this.startActive__I = v;
      this.startActiveIsSet = true;
    } else {
      this.startActive__I = v || undefined;
      this.startActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get startActive() {
    return this.startActive__I;
  }
  endActive__I?: Date = undefined;
  endActiveIsSet: boolean = false;
  set endActive(v: undefined | Date) {
    if (v !== undefined) {
      this.endActive__I = v;
      this.endActiveIsSet = true;
    } else {
      this.endActive__I = v || undefined;
      this.endActiveIsSet = false;
    }
    this.changeTracker = true;
  }
  get endActive() {
    return this.endActive__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  catalogName__I?: string = undefined;
  catalogNameIsSet: boolean = false;
  set catalogName(v: undefined | string) {
    if (v !== undefined) {
      this.catalogName__I = v;
      this.catalogNameIsSet = true;
    } else {
      this.catalogName__I = v || undefined;
      this.catalogNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get catalogName() {
    return this.catalogName__I;
  }
  categories__I?: CatalogCategoryDTOTracked[] = undefined;
  categoriesIsSet: boolean = false;
  set categories(v: undefined | CatalogCategoryDTOTracked[]) {
    if (v !== undefined) {
      this.categories__I = v;
      this.categoriesIsSet = true;
    } else {
      this.categories__I = v || undefined;
      this.categoriesIsSet = false;
    }
    this.changeTracker = true;
  }
  get categories() {
    return this.categories__I;
  }
  items__I?: CatalogItemPublicDTOTracked[] = undefined;
  itemsIsSet: boolean = false;
  set items(v: undefined | CatalogItemPublicDTOTracked[]) {
    if (v !== undefined) {
      this.items__I = v;
      this.itemsIsSet = true;
    } else {
      this.items__I = v || undefined;
      this.itemsIsSet = false;
    }
    this.changeTracker = true;
  }
  get items() {
    return this.items__I;
  }
  discounts__I?: CatalogDiscountPublicDTOTracked[] = undefined;
  discountsIsSet: boolean = false;
  set discounts(v: undefined | CatalogDiscountPublicDTOTracked[]) {
    if (v !== undefined) {
      this.discounts__I = v;
      this.discountsIsSet = true;
    } else {
      this.discounts__I = v || undefined;
      this.discountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get discounts() {
    return this.discounts__I;
  }
  taxes__I?: CatalogTaxDTOTracked[] = undefined;
  taxesIsSet: boolean = false;
  set taxes(v: undefined | CatalogTaxDTOTracked[]) {
    if (v !== undefined) {
      this.taxes__I = v;
      this.taxesIsSet = true;
    } else {
      this.taxes__I = v || undefined;
      this.taxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get taxes() {
    return this.taxes__I;
  }
  agreements__I?: AgreementDTOTracked[] = undefined;
  agreementsIsSet: boolean = false;
  set agreements(v: undefined | AgreementDTOTracked[]) {
    if (v !== undefined) {
      this.agreements__I = v;
      this.agreementsIsSet = true;
    } else {
      this.agreements__I = v || undefined;
      this.agreementsIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreements() {
    return this.agreements__I;
  }
  constructor(config?: CatalogPublicDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.categories?.forEach((a) => a.setIds());

    this.items?.forEach((a) => a.setIds());

    this.discounts?.forEach((a) => a.setIds());

    this.taxes?.forEach((a) => a.setIds());

    this.agreements?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: CatalogPublicDTOOptional,
    options?: AssignOptions,
  ): CatalogPublicDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.startActive &&
      this.startActiveApplyFilter(optionsRequired.filter)
    ) {
      this.startActive = config.startActive;
      if (optionsRequired.unassign) this.startActiveIsSet = false;
      else this.startActiveIsSet = true;
    }
    if (config.endActive && this.endActiveApplyFilter(optionsRequired.filter)) {
      this.endActive = config.endActive;
      if (optionsRequired.unassign) this.endActiveIsSet = false;
      else this.endActiveIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.catalogName &&
      this.catalogNameApplyFilter(optionsRequired.filter)
    ) {
      this.catalogName = config.catalogName;
      if (optionsRequired.unassign) this.catalogNameIsSet = false;
      else this.catalogNameIsSet = true;
    }
    if (
      config.categories &&
      this.categoriesApplyFilter(optionsRequired.filter)
    ) {
      this.categories = config.categories?.map(
        (a) => new CatalogCategoryDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.categoriesIsSet = false;
      else this.categoriesIsSet = true;
    }
    if (config.items && this.itemsApplyFilter(optionsRequired.filter)) {
      this.items = config.items?.map(
        (a) => new CatalogItemPublicDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.itemsIsSet = false;
      else this.itemsIsSet = true;
    }
    if (config.discounts && this.discountsApplyFilter(optionsRequired.filter)) {
      this.discounts = config.discounts?.map(
        (a) => new CatalogDiscountPublicDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.discountsIsSet = false;
      else this.discountsIsSet = true;
    }
    if (config.taxes && this.taxesApplyFilter(optionsRequired.filter)) {
      this.taxes = config.taxes?.map(
        (a) => new CatalogTaxDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.taxesIsSet = false;
      else this.taxesIsSet = true;
    }
    if (
      config.agreements &&
      this.agreementsApplyFilter(optionsRequired.filter)
    ) {
      this.agreements = config.agreements?.map(
        (a) => new AgreementDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.agreementsIsSet = false;
      else this.agreementsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogPublicDTOTrackedI {
    const cloned = {} as CatalogPublicDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.startActiveIsSetDeep() &&
      this.startActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.startActiveIsSet = true;
      cloned.startActive = this.startActive;
    } else {
      //cloned.startActiveIsSet = false
    }
    if (
      this.endActiveIsSetDeep() &&
      this.endActiveApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.endActiveIsSet = true;
      cloned.endActive = this.endActive;
    } else {
      //cloned.endActiveIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.catalogNameIsSetDeep() &&
      this.catalogNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.catalogNameIsSet = true;
      cloned.catalogName = this.catalogName;
    } else {
      //cloned.catalogNameIsSet = false
    }
    if (
      this.categoriesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.categoriesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.categoriesIsSet = true;
      cloned.categories = this.categories
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.categoriesIsSet = false
    }
    if (
      this.itemsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.itemsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemsIsSet = true;
      cloned.items = this.items
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.itemsIsSet = false
    }
    if (
      this.discountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.discountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.discountsIsSet = true;
      cloned.discounts = this.discounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.discountsIsSet = false
    }
    if (
      this.taxesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.taxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.taxesIsSet = true;
      cloned.taxes = this.taxes
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.taxesIsSet = false
    }
    if (
      this.agreementsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.agreementsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementsIsSet = true;
      cloned.agreements = this.agreements
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.agreementsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogPublicDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.startActiveApplyFilter(filter)) this.startActiveIsSet = false;

    if (!this.endActiveApplyFilter(filter)) this.endActiveIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.catalogNameApplyFilter(filter)) this.catalogNameIsSet = false;

    if (!this.categoriesApplyFilter(filter)) this.categoriesIsSet = false;

    this.categories?.forEach((a) => a.unassignAll(filter));
    if (!this.itemsApplyFilter(filter)) this.itemsIsSet = false;

    this.items?.forEach((a) => a.unassignAll(filter));
    if (!this.discountsApplyFilter(filter)) this.discountsIsSet = false;

    this.discounts?.forEach((a) => a.unassignAll(filter));
    if (!this.taxesApplyFilter(filter)) this.taxesIsSet = false;

    this.taxes?.forEach((a) => a.unassignAll(filter));
    if (!this.agreementsApplyFilter(filter)) this.agreementsIsSet = false;

    this.agreements?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.isDeleted,
      CatalogPublicDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.isNew,
      CatalogPublicDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  startActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.startActive,
      CatalogPublicDTOMeta,
      this.startActive,
      this,
    );
  }
  startActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.startActiveIsSet && this.startActiveApplyFilter(filter))
      return true;

    return false;
  }
  endActiveApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.endActive,
      CatalogPublicDTOMeta,
      this.endActive,
      this,
    );
  }
  endActiveIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.endActiveIsSet && this.endActiveApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.assignId,
      CatalogPublicDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  catalogNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.catalogName,
      CatalogPublicDTOMeta,
      this.catalogName,
      this,
    );
  }
  catalogNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.catalogNameIsSet && this.catalogNameApplyFilter(filter))
      return true;

    return false;
  }
  categoriesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.categories,
      CatalogPublicDTOMeta,
      this.categories,
      this,
    );
  }
  categoriesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.categoriesIsSet && this.categoriesApplyFilter(filter)) return true;

    return this.categories?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  itemsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.items,
      CatalogPublicDTOMeta,
      this.items,
      this,
    );
  }
  itemsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemsIsSet && this.itemsApplyFilter(filter)) return true;

    return this.items?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  discountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.discounts,
      CatalogPublicDTOMeta,
      this.discounts,
      this,
    );
  }
  discountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.discountsIsSet && this.discountsApplyFilter(filter)) return true;

    return this.discounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  taxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.taxes,
      CatalogPublicDTOMeta,
      this.taxes,
      this,
    );
  }
  taxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.taxesIsSet && this.taxesApplyFilter(filter)) return true;

    return this.taxes?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  agreementsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogPublicDTOMeta.agreements,
      CatalogPublicDTOMeta,
      this.agreements,
      this,
    );
  }
  agreementsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementsIsSet && this.agreementsApplyFilter(filter)) return true;

    return this.agreements?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.startActiveIsSetDeep(filter)) return true;
    if (this.endActiveIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.catalogNameIsSetDeep(filter)) return true;
    if (this.categoriesIsSetDeep(filter)) return true;
    if (this.itemsIsSetDeep(filter)) return true;
    if (this.discountsIsSetDeep(filter)) return true;
    if (this.taxesIsSetDeep(filter)) return true;
    if (this.agreementsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
